<template>
  <div class="oder_management">
    <div style="display: flex; justify-content: space-between">
      <div style="width: 50%">
        <div class="add-button">
          <el-button type="primary" @click="addNewRules" size="small">新增</el-button>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <eco-input
          prefix-icon="el-icon-search"
          class="quick-search"
          placeholder="请输入规则名称"
          :debounce="2000"
          clearable
          v-model="quickSearch"
          @keydown.enter.prevent.native="loadData()"
        >
        </eco-input>
      </div>
    </div>

    <div>
      <el-table
        ref="ecoTable"
        :style="{
          height: `${tableMaxHeight}` + 'px'
        }"
        :max-height="tableMaxHeight"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="规则名称" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="detail_count" label="规则条数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="时间" show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.createTime ? '创建:' + scope.row.createTime : ''}} <br>
            {{scope.row.updateTime ? '更新:' + scope.row.updateTime :''}}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="操作">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="edit(scope.row)">编辑</el-link> &nbsp;
            <el-link type="primary" :underline="false" @click="del(scope.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_bean">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <contract-rule-form
      ref="rulesForm"
      :rulesData="rulesData"
      :isEdit="isEdit"
      :dialogVisible.sync="dialogVisible"
      @beforeClose="close"
    ></contract-rule-form>
  </div>
</template>
<script>
import utils from '@/utils.js'
import contractRuleForm from './contractRuleForm.vue'
import { mapState } from 'vuex'
import styles from '@/assets/css/element-variables.scss'
export default {
  components: { contractRuleForm },
  props: {
    width: {
      type: String,
      default: styles.aside_width
    }
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      newsType: (state) => {
        return utils.findDictList('fxdj', state.user.allDataDict)
      }
    })
  },
  data() {
    return {
      height: '100%',
      tableData: [],
      tableMaxHeight: document.body.clientHeight - 250,
      total: 0,
      pageSize: 20,
      currentPage: 1,
      dialogVisible: false,
      tenantId: '-1',
      rulesData: {},
      name: '',
      isEdit: false,
      quickSearch: ''
    }
  },
  mounted() {
    if (sessionStorage.currentTenantId) {
      this.tenantId = sessionStorage.currentTenantId
    }
    this.loadData()
    this.calcTableHeight()
    this.$root.$on('resize', () => {
      this.calcTableHeight(600)
      this.$nextTick(() => {
        this.$refs.ecoTable.doLayout()
      })
    })
  },
  methods: {
    //重置搜索
    reset() {
      this.loadData()
    },
    //新增规则
    addNewRules() {
      this.isEdit = false
      this.rulesData = {}
      this.dialogVisible = true

    },
    //编辑规则
    edit(row) {
      this.isEdit = true
      this.rulesData = row
      this.dialogVisible = true
    },
    //删除规则
    del(row) {
      this.$http.remove('${portal}/rule/portal_contract_rule/' + row.id).then((res) => {
        let response = res.data
        if (response.state) {
          this.$message.info('删除规则成功！')
        } else {
          this.$message.error('删除规则失败！')
        }
        this.loadData()
      })
    },
    //关闭新增弹窗
    close() {
      this.dialogVisible = false
      this.loadData()
    },
    //表头样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const obj = {
        textAlign: 'center',
        backgroundColor: '#f3f3f3',
        color: '#333'
      }
      return obj
    },
    //列表样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (str.indexOf('金额') > -1 || str.indexOf('收款') > -1 || str.indexOf('提醒时间') > -1) {
          return 'text-align:right'
        } else {
          return 'text-align:center'
        }
      } else {
        return 'text-align:center'
      }
    },
    //table勾选事件
    handleSelectionChange() {},
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },

    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        const tableMin = 80
        this.tableMaxHeight = tablePanelHeight - tableMin
      }, delay || 0)
    },
    //table数据加载
    loadData() {
      this.tableData = []
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }

      let querys = []
      if (this.quickSearch) {
        querys.push(
            {
              group: 'quick',
              operation: 'LIKE',
              property: 'name',
              relation: 'AND',
              value: this.quickSearch
            }
        )
      }
      if (querys.length > 0) {
        params.querys = querys
      }
      this.showAdvancedSearch = false
      // if (prop) {
      //   params.sorter = [{ property: prop, direction: sort }];
      // }
      this.$http.post('${portal}/rule/portal_contract_rule/query', params).then((res) => {
        let response = res.data
        this.tableData = response.rows
        this.total = response.total
        this.pageSize = response.pageSize
        this.currentPage = response.page
        this.$refs.ecoTable.doLayout()
      })
    },
  }
}
</script>

<style scoped>
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
.col_style p {
  flex-shrink: 0;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}

/deep/.el-table--scrollable-y .el-table__body-wrapper {
  overflow-y: auto;
  max-height: !important;
}
.quick-search {
  width: 400px;
  height: 50px;
}
.oder_management {
  height: calc(100% - 20px);
  position: relative;
  padding-top: 16px
}
.quick-search + .el-divider {
  margin-right: 20px;
}
.advanceBtn {
  float: left;
  height: 32px;
  width: 80px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.advanceBtn2 {
  margin-left: 10px;
  float: left;
  border: 1px solid rgba(41, 124, 249, 100);
  height: 32px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(41, 124, 249, 100);
  padding: 0;
  width: 80px;
}
</style>
